import { FC } from 'react'

export const VisionMission: FC = () => {
  return (
    <div className="bg-neutral-100 py-8 md:py-10 mt-10 md:mt-40">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <div className="md:grid md:grid-cols-3 md:gap-10">
          <div>
            <h1 className="text-2xl font-medium text-neutral-900">
              What We Do
            </h1>
            <p className="text-md mt-4 text-neutral-900">
              For decades, John Robert Powers has helped individuals build confidence, develop
              essential skills, and grow in the way they communicate, present themselves, and
              connect with others. Through personal development, we help people become more
              confident, capable, and ready to make the most of life’s opportunities.
            </p>
          </div>
          <div className="flex flex-row space-x-5 mt-10 md:mt-0">
            <img
              className="h-8 w-auto"
              src={require('@assets/icons/mission.png')}
              alt="John Robert Powers"
            />
            <div>
              <h2 className="text-xl font-medium leading-relaxed">Our Purpose</h2>
              <p className="text-md mt-2 text-neutral-900">
                To empower individuals to navigate life with greater confidence,
                self-awareness, and a stronger sense of who they are.
              </p>
            </div>
          </div>
          <div className="flex flex-row space-x-5 mt-10 md:mt-0">
            <img
              className="h-8 w-auto"
              src={require('@assets/icons/vision.png')}
              alt="John Robert Powers"
            />
            <div>
              <h2 className="text-xl font-medium leading-relaxed">Our Vision</h2>
              <p className="text-md mt-2 text-neutral-900">
                To be a leading personal development institution that helps
                individuals achieve their full potential.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
